import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { firstValueFrom } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { JobPortalService } from 'src/app/services/job-portal.service';
import { noWhitespaceValidator } from 'src/app/validators/no-whitespace.validator';

declare const L: any;
declare var $: any;

@Component({
  selector: 'app-company-info-controller',
  templateUrl: './company-info-controller.component.html',
  styleUrls: ['./company-info-controller.component.css']
})
export class CompanyInfoControllerComponent implements OnInit {

  companyInfoData: any = [];
  filteredCompanyInfoData: any = [];
  singleCompanyInfoData: any = [];

  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  isLoading: any = false;
  isActionLoading: boolean = false;
  id: any;
  recordId: any = "";
  recordName: any = "";
  appPropertiesData: any = []
  cid: any;
  formSubmit: boolean = false;

  companyInfoForm: any | FormGroup;
  appPropertiesForm: any | FormGroup;
  propertiesFormSubmit: boolean = false;
  selectedCompanyInfoId: any;
  selectedCompanyInfo: any;
  selectedCompanyIsAppConfig: boolean = false;
  isEditAppProperties: boolean = false;
  appPropertiesId: string = "";
  appPropertiesVersion: number = 0;

  searchFilter: any = "";

  userForm: any | FormGroup;
  selectedCompanyForUser: any = null;
  userFormSubmit: boolean = false;
  buttonDisable: boolean = false;
  userParams: any = [];
  userTypes: any = [];
  userCred: any = [];
  usersWithoutCustomers: any[] = [];

  languages: any = [
    { label: 'English', value: 'en' },
    { label: 'French', value: 'fr' },
    { label: 'Hindi', value: 'hi' },
    { label: 'Telugu', value: 'te' },
    { label: 'German', value: 'de' }
  ];

  dashboardList = [
    { dashboardId: 1, dashboardName: "CRM Dashboard" },
    { dashboardId: 2, dashboardName: "Ecom Dashboard" },
    { dashboardId: 3, dashboardName: "Inventory Dashboard" },
    { dashboardId: 4, dashboardName: "AMP Dashboard" },
    { dashboardId: 5, dashboardName: "Tickets Dashboard" },
    { dashboardId: 6, dashboardName: "Asset cost Dashboard" },
    { dashboardId: 7, dashboardName: "Asset distribution Dashboard" },
  ];
  dashboardSelectedList: any = [];
  dashboardDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'dashboardId',
    textField: 'dashboardName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  locationList: any = [];
  locationSelectedList: any = [];
  locationDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'locationId',
    textField: 'zone',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  objectGroupData: any = [];
  objectGroupDataSelectedList: any = [];
  objectGroupDataDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'objectGroupMasterId',
    textField: 'groupName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  branchList: any = [];
  branchSelectedList: any = [];
  branchDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'branchMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  departmentList: any = [];
  departmentSelectedList: any = [];
  departmentDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'departmentInfoId',
    textField: 'departmentName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  // Add Location Modal Variables
  locationForm: any | FormGroup;
  formSubmitLocation: boolean = false;
  latLng: any = [];
  private mapLocation!: any; // Leaflet map
  drawnItems: any;
  defaultCenter: any = [17.4065, 78.4772];
  defaultZoom: any = 14;
  userList: any = [];
  userSelectedList: any = [];
  userDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 6,
    allowSearchFilter: true
  };

  // Add Group Modal Variables
  groupForm: any | FormGroup;
  isSubmitedGroup: boolean = false;

  // Add Branch Modal Variables
  branchForm: any | FormGroup;
  formSubmitBranch: boolean = false;
  dealerList: any = [];
  distributorList: any = [];

  // Add Department Modal Variables
  departmentForm: any | FormGroup;
  formSubmitDepartment: boolean = false;

  fixedKeys: { key: string; label: string }[] = [
    { key: 'AMS_SPECIFIC', label: 'AMS Specific' },
    { key: 'AUTO_TICKET_CREATION_AT_INVOICE_PAYMENT', label: 'Auto Ticket Creation At Invoice Payment' },
    { key: 'AWS_S3_ACCESS_KEY', label: 'AWS S3 Access Key' },
    { key: 'AWS_S3_BUCKET_NAME', label: 'AWS S3 Bucket Name' },
    { key: 'AWS_S3_SECRET_KEY', label: 'AWS S3 Secret Key' },
    { key: 'COMPANY_NAME', label: 'Company Name' },
    { key: 'CUSTOMER_AUTO_APPROVED', label: 'Customer Auto Approved' },
    { key: 'JAZE_API_KEY', label: 'Jaze API Key' },
    { key: 'JAZE_API_TOKEN', label: 'Jaze API Token' },
    { key: 'JAZE_DOMAIN_URL', label: 'Jaze Domain URL' },
    { key: 'JWT_PRIVATE_KEY', label: 'JWT Private Key' },
    { key: 'JWT_PUBLIC_KEY', label: 'JWT Public Key' },
    { key: 'MATERIAl_ISSUE_SEQUENE_AUTOGENERATE', label: 'Material Issue Sequence Autogenerate' },
    { key: 'MSG91_AUTHKEY', label: 'MSG91 Authkey' },
    { key: 'MSG91_CREATE_TICKET_FOR_REGISTERED_ONLY', label: 'MSG91 Create Ticket For Registered Only' },
    { key: 'MSG91_TASK_STATUS_UPDATE_TO_TECHNICIAN', label: 'MSG91 Task Status Update To Technician' },
    { key: 'MSG91_WHATSAPP_NUMBER', label: 'MSG91 Whatsapp Number' },
    { key: 'MSG91_WHATSAPP_TICKET_CREATION_DEFAULT_ADMIN_USERID', label: 'MSG91 Whatsapp Ticket Creation Default Admin UserID' },
    { key: 'MSG_WHATSAPP_NUMBER', label: 'MSG Whatsapp Number' },
    { key: 'NOTIFICATION_URL', label: 'Notification URL' },
    { key: 'RAZORPAY_CURRENCY', label: 'Razorpay Currency' },
    { key: 'RAZORPAY_KEY_ID', label: 'Razorpay Key ID' },
    { key: 'RAZORPAY_KEY_SECRET', label: 'Razorpay Key Secret' },
    { key: 'SENDGRID_FROM_EMAIL', label: 'SendGrid From Email' },
    { key: 'SENDGRID_KEY', label: 'SendGrid Key' },
    { key: 'SMS_API_KEY', label: 'SMS API Key' },
    { key: 'SMS_API_URL', label: 'SMS API URL' },
    { key: 'SMS_SENDER', label: 'SMS Sender' },
    { key: 'TPM_AUTHORIZED_USER', label: 'TPM Authorized User' },
    { key: 'UPDATED_MATERIAL_ON_ISSUED', label: 'Updated Material On Issued' },
    { key: 'UPDATE_BALANCES_ON_MATERIAL_ISSUE_APPROVAL', label: 'Update Balances On Material Issue Approval' },
    { key: 'USER_CREATION_ON_VENDOR_APPROVED', label: 'User Creation On Vendor Approved' },
    { key: 'VENDOR_AUTO_APPROVED', label: 'Vendor Auto Approved' },
    { key: 'ZABBIX_API_TOKEN', label: 'Zabbix API Token' },
    { key: 'ZABBIX_API_URL', label: 'Zabbix API URL' },
    { key: 'rzp_company_name', label: 'RZP Company Name' },
    { key: 'EPISODE_URL', label: 'Episode URL' },

    { key: 'STORAGE_ENDPOINT', label: 'Storage Endpoint' },
    { key: 'STORAGE_REGION', label: 'Storage Region' }

  ];

  industryTypes = [
    { value: 'SERVICE_INDUSTRY', viewValue: 'Service Industry' },
    { value: 'MANUFACTURING_INDUSTRY', viewValue: 'Manufacturing Industry' }
  ];

  getIndustryViewValue(value: any): string {
    if (!value) return " -- ";
    const industry = this.industryTypes.find(ind => ind.value === value);
    return industry ? industry.viewValue : value;
  }

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService,
    private job_portal_service: JobPortalService
  ) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid');
    if (sessionStorage.getItem('userCreds')) {
      this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    }

    this.initForms();
    this.initUserForm();
    this.getAllCompanyInfo();

    this.getParamByType();
    // this.getParam();
    this.getAllLocation();
    this.getAllGroupList();
    this.getAllDepartment_info();
    this.getAllBranch();
    this.getUsersWithoutCustomers();

    // Init variables for new modals
    this.getUsersForLocation();
    this.getAllIdistributor();
    this.getAllIDealer();
  }

  initUserForm() {
    this.userForm = this.fb.group({
      userName: ['', [Validators.required]],
      userMobileNo: ['', [Validators.required, Validators.maxLength(20), Validators.minLength(9), Validators.pattern("[0-9 ]{10}")]],
      userEmail: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$")]],
      password: ['', [Validators.required]],
      userType: ['BO', [Validators.required]],
      reportsTo: [''],
      companyName: [''],
      language: [''],
      location: ['']
    });
  }

  initForms() {
    this.companyInfoForm = this.fb.group({
      companyName: ['', [Validators.required]],
      boname: ['', [Validators.required]],
      bophNo: ['', [Validators.required]],
      boemail: ['', [Validators.required, Validators.email]],
      boindustry: ['', [Validators.required]],
      keyValuePair: this.fb.array([])
    });

    this.appPropertiesForm = this.fb.group({
      keyValuePair: this.fb.array([])
    });

    this.initFixedKeys();
    this.initAppPropertiesFixedKeys();
    this.initAddEntityForms();
  }

  initAddEntityForms() {
    this.locationForm = this.fb.group({
      zone: ['', [Validators.required]],
      city: ['', [Validators.required]],
      provinceOrState: ['', [Validators.required]],
      country: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      stockPoint: [false],
    });

    this.groupForm = this.fb.group({
      groupName: ['', [Validators.required, noWhitespaceValidator]]
    });

    this.branchForm = this.fb.group({
      name: ['', [Validators.required]],
      latitude: [''],
      longitude: [''],
      address: ['', [Validators.required]],
      description: [''],
      internal: [true],
      belongsToType: [''],
      belongsToId: ['']
    });

    this.departmentForm = this.fb.group({
      departmentName: ['', [Validators.required]]
    });
  }

  get keyValuePair(): FormArray {
    return this.companyInfoForm.get('keyValuePair') as FormArray;
  }

  get appKeyValuePair(): FormArray {
    return this.appPropertiesForm.get('keyValuePair') as FormArray;
  }

  initFixedKeys() {
    this.fixedKeys.forEach(item => {
      this.keyValuePair.push(this.fb.group({
        key: [item.key, Validators.required],
        label: [item.label],
        value: ['']
      }));
    });
  }

  initAppPropertiesFixedKeys() {
    this.fixedKeys.forEach(item => {
      this.appKeyValuePair.push(this.fb.group({
        key: [item.key, Validators.required],
        label: [item.label],
        value: [''],
        isEditMode: [false],
        originalValue: [''],
        originalData: [null]
      }));
    });
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
    // this.getAllCompanyInfo();
  }

  getAllCompanyInfo() {
    this.isLoading = true;
    this.generic_service.getAllCompanyInfo(this.cid).subscribe(
      (response: any) => {
        this.companyInfoData = response.response || [];
        this.filteredCompanyInfoData = [...this.companyInfoData];
        this.totalRecords = this.filteredCompanyInfoData.length;
        this.isLoading = false;
      },
      (err: any) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  getCompanyInfoByWildSearch() {
    if (!this.searchFilter) {
      this.filteredCompanyInfoData = [...this.companyInfoData];
      this.totalRecords = this.filteredCompanyInfoData.length;
      return;
    }
    const search = this.searchFilter.toLowerCase();
    this.filteredCompanyInfoData = this.companyInfoData.filter((company: any) =>
      (company.companyName && company.companyName.toLowerCase().includes(search)) ||
      (company.boemail && company.boemail.toLowerCase().includes(search))
    );
    this.totalRecords = this.filteredCompanyInfoData.length;
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    this.getAllCompanyInfo();
  }


  viewCompanyInfoById(company: any) {
    this.isActionLoading = true;
    this.singleCompanyInfoData = []
    this.generic_service.getCompanyInfoById(company.companyInfoId, company.companyInfoId).subscribe(
      (response: any) => {
        let data = response.response || response;

        this.generic_service.getAllAppPropertiesConfig(company.companyInfoId).subscribe(
          (propResponse: any) => {
            this.isActionLoading = false;
            let properties = propResponse.response || [];

            data.keyValuePair = properties.map((prop: any) => ({
              key: prop.key,
              value: prop.value
            }));

            this.singleCompanyInfoData = [data];
          },
          (propErr: any) => {
            this.isActionLoading = false;
            this.singleCompanyInfoData = [data];
            console.error("Error fetching app properties config", propErr);
          }
        );
      },
      (err: any) => {
        this.isActionLoading = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error fetching company info details");
      }
    );
  }

  openPropertiesModal(company: any) {
    this.selectedCompanyInfoId = company.companyInfoId;
    this.selectedCompanyIsAppConfig = company.appPropertiesConfig || false;
    this.selectedCompanyInfo = null;
    this.propertiesFormSubmit = false;
    this.isEditAppProperties = false;
    this.appPropertiesId = "";
    this.appPropertiesVersion = 0;

    this.appPropertiesForm.reset();
    this.appKeyValuePair.clear();
    this.initAppPropertiesFixedKeys();

    this.isActionLoading = true;
    this.generic_service.getAllAppPropertiesConfig(company.companyInfoId).subscribe(
      (propResponse: any) => {
        this.isActionLoading = false;
        let properties = propResponse.response || [];
        this.appPropertiesData = propResponse.response || [];

        if (properties.length > 0) {
          this.isEditAppProperties = true;
          this.appPropertiesId = properties[0].id || "";
          this.appPropertiesVersion = properties[0].version || 0;
          this.selectedCompanyIsAppConfig = true;

          this.appKeyValuePair.controls.forEach(control => {
            let key = control.get('key')?.value;
            let match = properties.find((p: any) => p.key === key);
            if (match) {
              control.get('value')?.setValue(match.value);
              control.get('originalValue')?.setValue(match.value);
              control.get('originalData')?.setValue(match);
            }
          });
        }
      },
      (err: any) => {
        this.isActionLoading = false;
        console.error("Error fetching app properties config", err);
      }
    );
  }

  getProperties(companyInfo: any) {
    if (!companyInfo) return;

    this.isActionLoading = true;

    this.generic_service.getAllAppPropertiesConfig(companyInfo.companyInfoId).subscribe(
      (propResponse: any) => {
        this.isActionLoading = false;
        let properties = propResponse.response || [];

        // Clear current values to populate the copied ones
        this.appKeyValuePair.controls.forEach(control => {
          control.get('value')?.setValue('');
        });

        if (properties.length > 0) {
          this.appKeyValuePair.controls.forEach(control => {
            let key = control.get('key')?.value;
            let match = properties.find((p: any) => p.key === key);
            if (match) {
              control.get('value')?.setValue(match.value);
              // We intentionally do not set originalData here since it's a copy for a new save
            }
          });
        }
      },
      (err: any) => {
        this.isActionLoading = false;
        console.error("Error fetching app properties config for copy", err);
      }
    );
  }

  editProperty(index: number) {
    this.appKeyValuePair.controls.forEach((c, i) => {
      if (i === index) {
        c.get('isEditMode')?.setValue(true);
      } else {
        c.get('isEditMode')?.setValue(false);
      }
    });
  }

  cancelEditProperty(index: number) {
    let control = this.appKeyValuePair.controls[index];
    control.get('value')?.setValue(control.get('originalValue')?.value);
    control.get('isEditMode')?.setValue(false);
  }

  submitProperty(index: number) {
    let control = this.appKeyValuePair.controls[index];
    let originalData = control.get('originalData')?.value;
    let newValue = control.get('value')?.value;
    console.log(this.appPropertiesData);
    console.log(control.value);
    console.log(originalData);
    if (originalData == null) {

      if (control.value.value == "") {
        this.toastr.error("please fill value")
        return
      }

      let body: any = {
        "version": 0,
        "isActive": true,
        "description": "",
        "clientId": String(this.selectedCompanyInfoId),
        "key": control.value.key,
        "value": control.value.value,
        "qrCodeImageLink": "",
        "updateDate": new Date().getTime(),
        "modifiedBy": sessionStorage.getItem('username') || "",
        "status": 0,
        "cid": this.selectedCompanyInfoId
      }
      console.log(body)
      this.generic_service.addSingleAppPropertiesConfig(body).subscribe(
        (response: any) => {
          console.log(response)

          control.get('originalValue')?.setValue(newValue);
          if (originalData) {
            originalData.value = newValue;
            control.get('originalData')?.setValue(originalData);
          } else if (response.response) {
            control.get('originalData')?.setValue(response.response);
          }
          control.get('isEditMode')?.setValue(false);
          this.toastr.success(response.message || "Property updated successfully");
        }, (err: any) => {
          console.log(err)
        }
      )
    } else {

      let payload = {
        "version": originalData ? originalData.version : 0,
        "isActive": originalData ? originalData.isActive : true,
        "description": originalData && originalData.description ? originalData.description : "App Properties",
        "id": originalData ? originalData.id : "",
        "clientId": String(this.selectedCompanyInfoId),
        "key": control.get('key')?.value,
        "value": newValue,
        "qrCodeImageLink": originalData && originalData.qrCodeImageLink ? originalData.qrCodeImageLink : "",
        "updateDate": originalData ? originalData.updateDate : 0,
        "modifiedBy": sessionStorage.getItem('username') || "",
        "status": originalData ? originalData.status : 0,
        "cid": String(this.selectedCompanyInfoId)
      };

      this.generic_service.updateAppProperty(payload).subscribe(
        (response: any) => {
          control.get('originalValue')?.setValue(newValue);
          if (originalData) {
            originalData.value = newValue;
            control.get('originalData')?.setValue(originalData);
          } else if (response.response) {
            control.get('originalData')?.setValue(response.response);
          }
          control.get('isEditMode')?.setValue(false);
          this.toastr.success(response.message || "Property updated successfully");
        },
        (err: any) => {
          this.toastr.error(err.error?.errors?.[0]?.description || "Error updating property");
        }
      );
    }


  }

  saveAppProperties() {
    if (this.propertiesFormSubmit) {
      return;
    }
    this.propertiesFormSubmit = true;

    let formValues = this.appPropertiesForm.value;

    let kvs = formValues.keyValuePair
      .filter((kv: any) => kv.value !== null && kv.value !== '')
      .map((kv: any) => ({ key: kv.key, value: kv.value }));

    let addPayloads = kvs.map((kv: any) => ({
      "version": this.appPropertiesVersion,
      "isActive": true,
      "description": "App Properties",
      "clientId": String(this.selectedCompanyInfoId),
      "key": kv.key,
      "value": kv.value,
      "qrCodeImageLink": "",
      "updateDate": 0,
      "modifiedBy": sessionStorage.getItem('username') || "",
      "status": 0,
      "cid": String(this.selectedCompanyInfoId)
    }));

    let addBody = {
      "appPropertiesConfigPayloads": addPayloads
    };

    let request = this.generic_service.addAppPropertiesConfig(addBody);

    request.subscribe(
      (response: any) => {
        this.propertiesFormSubmit = false;
        this.appPropertiesForm.reset();
        this.appKeyValuePair.clear();
        this.initAppPropertiesFixedKeys();
        this.getAllCompanyInfo();
        this.cancelModel();
        this.toastr.success(response.message || "Successfully Added Properties");
      },
      (err: any) => {
        this.propertiesFormSubmit = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error adding properties");
      }
    );
  }

  addCompanyInfo() {
    if (this.formSubmit) {
      return;
    }
    this.formSubmit = true;

    if (!this.companyInfoForm.valid) {
      this.formSubmit = false;
      this.toastr.error("please fill required fields");
      return;
    }

    let formValues = this.companyInfoForm.value;

    // Construct body exactly as required
    let body = {
      "companyName": formValues.companyName,
      "bOName": formValues.boname,
      "bOPhNo": Number(formValues.bophNo),
      "bOEmail": formValues.boemail,
      "bOIndustry": formValues.boindustry,
      "keyValuePair": [],
      "isBlocked": false,

      // "keyValuePair": formValues.keyValuePair
      //   .filter((kv: any) => kv.value !== null && kv.value !== '')
      //   .map((kv: any) => ({ key: kv.key, value: kv.value })),
      "cid": Number(this.cid)
    };

    this.generic_service.addCompanyInfo(body).subscribe(
      (response: any) => {
        this.formSubmit = false;
        this.companyInfoForm.reset();
        // re-initialize keys after reset
        this.keyValuePair.clear();
        this.initFixedKeys();

        this.cancelModel();
        this.getAllCompanyInfo();
        this.toastr.success(response.message || "Successfully Added");
      },
      (err: any) => {
        this.formSubmit = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error adding company info");
      }
    );
  }

  deleteCompanyInfo() {
    this.generic_service.deleteCompanyInfo(this.id).subscribe(
      (response: any) => {
        this.toastr.success(response.message || "Successfully Deleted");
        this.getAllCompanyInfo();
        this.cancelModel();
        this.clearData();
      },
      (error: any) => {
        this.toastr.error(error.error?.errors?.[0]?.description || "Error deleting company info");
      }
    );
  }

  deleteIdSelect(id: any, list: any) {
    this.id = id;
    this.recordId = list.id || id;
    this.recordName = list.companyName;
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  closePopUp() {
    this.recordId = "";
    this.recordName = "";
    this.formSubmit = false;
    this.companyInfoForm.reset();
    this.keyValuePair.clear();
    this.initFixedKeys();

    this.singleCompanyInfoData = []
    this.selectedCompanyInfoId = "";
    this.propertiesFormSubmit = false;
    this.appPropertiesForm.reset();
    this.appKeyValuePair.clear();
    this.initAppPropertiesFixedKeys();
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click();
    document.getElementById("closeModalButton1")?.click();
    document.getElementById("closeModalButton2")?.click();
    document.getElementById("closeModalButton3")?.click();
  }

  loadDependentDataByCid(cid: any) {
    this.getAllBranchByCid(cid);
    this.getAllDepartment_infoByCid(cid);
    this.getAllGroupListByCid(cid);
    this.getAllLocationByCid(cid);
  }

  getLabel(key: string): string {
    const matchedKey = this.fixedKeys.find(item => item.key === key);
    return matchedKey ? matchedKey.label : key;
  }

  getAllBranch() {
    this.generic_service.getBranch().subscribe(
      (response: any) => { this.branchList = response.response; }
    );
  }

  getAllBranchByCid(cid: any) {
    this.generic_service.getBranchByCid(cid).subscribe(
      (response: any) => {
        console.log("branch response", response)
        this.branchList = response.response;
      }
    );
  }

  getAllDepartment_info() {
    this.generic_service.getAllDepartment_info().subscribe(
      (res: any) => { this.departmentList = res.response; },
      (err: any) => { console.log(err); }
    );
  }

  getAllDepartment_infoByCid(cid: any) {
    this.generic_service.getAllDepartment_infoByCid(cid).subscribe(
      (res: any) => { this.departmentList = res.response; },
      (err: any) => { console.log(err); }
    );
  }

  getAllGroupList() {
    this.generic_service.getAllGroupList().subscribe(
      (res: any) => { this.objectGroupData = res.response || []; },
      (err: any) => { console.log(err); }
    );
  }

  getAllGroupListByCid(cid: any) {
    this.generic_service.getAllGroupListByCid(cid).subscribe(
      (res: any) => { this.objectGroupData = res.response || []; },
      (err: any) => { console.log(err); }
    );
  }

  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => { this.locationList = res.response || []; },
      (err: any) => { console.log(err); }
    );
  }

  getAllLocationByCid(cid: any) {
    this.generic_service.getAllLocationByCid(cid).subscribe(
      (res: any) => { this.locationList = res.response || []; },
      (err: any) => { console.log(err); }
    );
  }

  getUsersWithoutCustomers() {
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        this.usersWithoutCustomers = res.response;
      }
    )
  }

  async getParamByType() {
    let paramType = "USERPARAMS";
    try {
      const response: any = await firstValueFrom(this.generic_service.getParamByType(paramType));
      this.userParams = [];
      for (let key of response.response) {
        if (key.boxType != null && key.boxType != "" && key.boxType != undefined) {
          if (key.boxType == 'Dropdown') {
            if (key.api != '' && key.api != null && key.api != undefined) {
              const res: any = await firstValueFrom(this.generic_service.getByApiName(key.api));
              key.possibleValue = res.response;
            }
          }
          let obj = {
            name: key.name,
            boxType: key.boxType,
            isMandatory: key.isMandatory,
            possibleValue: key.possibleValue,
            value: "",
          };
          this.userParams.push(obj);
        }
      }
    } catch (err) {
      console.error("Error fetching user params:", err);
    }
  }

  // getParam() {
  //   let paramType = "USERTYPE";
  //   this.generic_service.getParamByType(paramType).subscribe(
  //     (response: any) => {
  //       for (let key of response.response) {
  //         this.userTypes = key.possibleValue;
  //       }
  //     },
  //     (err: any) => { console.log(err); }
  //   );
  // }

  openAddUserModal(company: any) {
    this.selectedCompanyForUser = company;
    console.log(company)
    this.loadDependentDataByCid(company?.cid)
    this.userForm.reset({
      userType: 'BO',
      userName: company?.bOName,
      userMobileNo: company?.bOPhNo,
      userEmail: company?.bOEmail,
    });
    this.dashboardSelectedList = [];
    this.locationSelectedList = [];
    this.objectGroupDataSelectedList = [];
    this.branchSelectedList = [];
    this.departmentSelectedList = [];
    this.userFormSubmit = false;
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  saveUser() {
    if (!this.userForm.valid) {
      this.userFormSubmit = true;
      this.toastr.error("please fill required fields");
      return;
    }

    if (this.userFormSubmit) return;
    this.userFormSubmit = true;
    this.buttonDisable = true;

    let keyValues: any = [];
    for (let i = 0; i < this.userParams.length; i++) {
      keyValues.push({
        "key": this.userParams[i].name,
        "value": this.userParams[i].value
      });
    }

    let dashboardIds: any = [];
    for (let list of this.dashboardSelectedList) { dashboardIds.push(list.dashboardId); }

    let locations: any = [];
    for (let list of this.locationSelectedList) { locations.push(list.locationId); }

    let groupMasterList = this.objectGroupData.filter((list: any) =>
      this.objectGroupDataSelectedList.some(
        (selected: any) => selected.objectGroupMasterId === list.objectGroupMasterId
      )
    );

    let branch: any = [];
    for (let list of this.branchSelectedList) { branch.push(list.branchMasterId); }

    let department: any = [];
    for (let list of this.departmentSelectedList) { department.push(list.departmentInfoId); }

    let body: any = {
      "version": 0,
      "isActive": true,
      "description": "",
      "userType": String(this.userForm.get('userType').value),
      "userName": String(this.userForm.get('userName').value),
      "userMobileNo": String(this.userForm.get('userMobileNo').value),
      "userEmail": String(this.userForm.get('userEmail').value),
      "password": String(this.userForm.get('password').value),
      "imageURL": "",
      "location": "",
      "dashboardIds": dashboardIds,
      "otp": "",
      "otpGenerateDateTime": 0,
      "keyValues": keyValues,
      "cid": this.selectedCompanyForUser.companyInfoId,
      "companyName": this.selectedCompanyForUser.companyName || '',
      "locations": locations,
      "department": department,
      "branch": branch,
      "groupMasterList": groupMasterList,
      "preferences": {
        "localization": {
          "country": "",
          "language": this.userForm.get('language').value,
          "timezone": "",
          "dateFormat": "",
          "currency": ""
        }
      },
    };

    if (this.userForm.get('reportsTo').value != null && this.userForm.get('reportsTo').value != "") {
      body.reportsTo = Number(this.userForm.get('reportsTo').value);
    }

    this.generic_service.addlogedUsers(body).subscribe(
      (response: any) => {
        this.getAllCompanyInfo();
        this.toastr.success(response.message || response.response?.message || "User created successfully");
        document.getElementById('closeUserModalButton')?.click();
        this.buttonDisable = false;
        this.userFormSubmit = false;
      },
      (err: any) => {
        this.userFormSubmit = false;
        this.buttonDisable = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error creating user");
      }
    );
  }

  // ---------- MODAL OPEN / CLOSE HANDLERS ----------

  openAddLocationModal() {
    document.getElementById('closeUserModalButton')?.click();
    document.getElementById('openAddLocationModalBtn')?.click();
    this.mapLoadLocation();
  }

  closeAddLocationModal() {
    this.locationForm.reset();
    this.userSelectedList = [];
    this.formSubmitLocation = false;
    this.clearMapLocation();
    document.getElementById('openAddUserModalBtn')?.click();
  }

  openAddGroupModal() {
    document.getElementById('closeUserModalButton')?.click();
    document.getElementById('openAddGroupModalBtn')?.click();
  }

  closeAddGroupModal() {
    this.groupForm.reset();
    this.isSubmitedGroup = false;
    document.getElementById('openAddUserModalBtn')?.click();
  }

  openAddBranchModal() {
    document.getElementById('closeUserModalButton')?.click();
    document.getElementById('openAddBranchModalBtn')?.click();
    this.branchForm.patchValue({ internal: true });
  }

  closeAddBranchModal() {
    this.branchForm.reset();
    this.branchForm.patchValue({ internal: true });
    this.formSubmitBranch = false;
    document.getElementById('openAddUserModalBtn')?.click();
  }

  openAddDepartmentModal() {
    document.getElementById('closeUserModalButton')?.click();
    document.getElementById('openAddDepartmentModalBtn')?.click();
  }

  closeAddDepartmentModal() {
    this.departmentForm.reset();
    this.formSubmitDepartment = false;
    document.getElementById('openAddUserModalBtn')?.click();
  }

  // ---------- FETCH DATA FOR MODALS ----------

  getUsersForLocation() {
    this.generic_service.getUsers().subscribe(
      (response: any) => {
        if (response.response == null || response.response.length == 0 || response.response == undefined) {
          this.userList = [];
          return;
        }
        this.userList = response.response;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  getAllIdistributor() {
    this.generic_service.getAllIdistributor(0, 1).subscribe(
      (res: any) => {
        if (res.response && res.response.totalRecords) {
          this.generic_service.getAllIdistributor(0, res.response.totalRecords).subscribe(
            (response: any) => {
              this.distributorList = response.response.idistributorList;
            },
            (err: any) => { console.log(err); }
          );
        }
      },
      (err: any) => { console.log(err); }
    );
  }

  getAllIDealer() {
    this.generic_service.getAllIdealer(0, 1).subscribe(
      (res: any) => {
        if (res.response && res.response.totalRecords) {
          this.generic_service.getAllIdealer(0, res.response.totalRecords).subscribe(
            (response: any) => {
              this.dealerList = response.response.idealerList;
            },
            (err: any) => { console.log(err); }
          );
        }
      },
      (err: any) => { console.log(err); }
    );
  }

  // ---------- LOCATION MAP LOGIC ----------

  mapLoadLocation() {
    setTimeout(() => {
      if (this.mapLocation) {
        this.mapLocation.remove();
        this.mapLocation = undefined as any;
      }
      this.initMapLocation();
      if (this.mapLocation) {
        this.mapLocation.invalidateSize();
      }
    }, 500);
  }

  private initMapLocation(): void {
    if (typeof L === 'undefined') return;
    this.mapLocation = L.map('mapLocation', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; OpenStreetMap'
    });
    tiles.addTo(this.mapLocation);

    this.drawnItems = L.featureGroup().addTo(this.mapLocation);

    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: this.drawnItems
      },
      draw: {
        marker: false,
        polygon: true,
        polyline: false,
        circle: false,
        rectangle: false,
        circlemarker: false
      }
    });
    this.mapLocation.addControl(drawControl);

    this.mapLocation.on(L.Draw.Event.CREATED, (event: any) => {
      const layer = event.layer;
      this.drawnItems.clearLayers();
      const points = layer.getLatLngs();

      const flatPoints = Array.isArray(points[0]) ? points[0] : points;
      let latLng: any = flatPoints.map((pt: any) => ({
        lat: pt.lat.toString(),
        lng: pt.lng.toString()
      }));

      this.latLng = latLng;
      if (event.layerType === 'polygon') {
        this.drawnItems.addLayer(layer);
      }
    });
  }

  clearMapLocation(): void {
    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }
    this.latLng = [];
  }

  // ---------- SUBMIT METHODS ----------

  addLocation() {
    if (this.formSubmitLocation) return;
    this.formSubmitLocation = true;

    if (!this.locationForm.valid) {
      this.formSubmitLocation = false;
      this.toastr.error("Please fill in all required fields for Location");
      return;
    }
    if (this.locationForm.get('stockPoint').value && this.userSelectedList.length === 0) {
      this.formSubmitLocation = false;
      this.toastr.error("Please select at least one user when Stock Point is enabled");
      return;
    }

    let points: any = [];
    for (let list of this.latLng) {
      let obj = {
        "x": parseFloat(list.lng),
        "y": parseFloat(list.lat)
      };
      points.push(obj);
    }

    let usersResponsiblePayload: any = [];
    for (let user of this.userSelectedList) {
      let fullUser = this.userList.find((u: any) => u.userId === user.userId);
      if (fullUser) {
        usersResponsiblePayload.push({
          version: fullUser.version || 0,
          isActive: fullUser.isActive || true,
          description: fullUser.description || "",
          userId: fullUser.userId,
          userName: fullUser.userName,
          userMobileNo: fullUser.userMobileNo || "",
          userEmail: fullUser.userEmail || "",
          cid: this.cid
        });
      } else {
        usersResponsiblePayload.push({
          version: 0,
          isActive: true,
          description: "",
          userId: user.userId,
          userName: user.userName,
          userMobileNo: "",
          userEmail: "",
          cid: this.cid
        });
      }
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "country": this.locationForm.get('country').value,
      "city": this.locationForm.get('city').value,
      "provinceOrState": this.locationForm.get('provinceOrState').value,
      "postalCode": this.locationForm.get('postalCode').value,
      "district": "",
      "zone": this.locationForm.get('zone').value,
      "imageUrl": "",
      "latLng": [],
      "lngLat": points,
      "geometry": {
        "points": [],
        "coordinates": [
          {
            "type": "",
            "coordinates": []
          }
        ],
        "type": ""
      },
      "cid": Number(this.selectedCompanyForUser.cid),
      "stockPoint": this.locationForm.get('stockPoint').value || false,
      "usersResponsible": usersResponsiblePayload,
    };

    this.job_portal_service.addLocation(body).subscribe(
      (response: any) => {
        this.formSubmitLocation = false;
        this.toastr.success(response.message || "Location Added");
        this.getAllLocationByCid(this.selectedCompanyForUser.cid);
        document.getElementById('closeAddLocationModalBtn')?.click();
      },
      (err: any) => {
        this.formSubmitLocation = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error adding location");
      }
    );
  }

  blockSpecialChars(event: KeyboardEvent): boolean {
    const allowedRegex = /^[a-zA-Z0-9 ]+$/;
    const key = event.key;
    if (key === 'Enter') return true;
    if (!allowedRegex.test(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  addObjectGroup() {
    if (this.isSubmitedGroup) return;

    if (!this.groupForm.valid) {
      this.toastr.error("Please fill in all required fields for Group");
      this.isSubmitedGroup = false;
      return;
    }

    this.isSubmitedGroup = true;
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "groupName": this.groupForm.get('groupName').value.trim(),
      "cid": Number(this.selectedCompanyForUser.cid),
    };

    this.generic_service.addObjectGroup(body).subscribe(
      (response: any) => {
        this.isSubmitedGroup = false;
        this.toastr.success(response.message || "Group Added");
        this.getAllGroupListByCid(this.selectedCompanyForUser.cid);
        document.getElementById('closeAddGroupModalBtn')?.click();
      },
      (error: any) => {
        this.isSubmitedGroup = false;
        this.toastr.error(error.error?.errors?.[0]?.description || "Error adding group");
      }
    );
  }

  addBranch() {
    if (this.formSubmitBranch) return;
    this.formSubmitBranch = true;

    if (!this.branchForm.valid) {
      this.formSubmitBranch = false;
      this.toastr.error("Please fill in all required fields for Branch");
      return;
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.branchForm.get('description').value || ""),
      "name": String(this.branchForm.get('name').value),
      "latitude": String(this.branchForm.get('latitude').value || ""),
      "longitude": String(this.branchForm.get('longitude').value || ""),
      "address": String(this.branchForm.get('address').value),
      "cid": Number(this.selectedCompanyForUser.cid),
      "internal": this.branchForm.get('internal').value,
      "belongsToType": String(this.branchForm.get('belongsToType').value || ""),
      "belongsToId": Number(this.branchForm.get('belongsToId').value || 0)
    };

    this.generic_service.addBranch(body).subscribe(
      (response: any) => {
        this.formSubmitBranch = false;
        this.toastr.success(response.message || "Branch Added");
        this.getAllBranchByCid(this.selectedCompanyForUser.cid);
        document.getElementById('closeAddBranchModalBtn')?.click();
      },
      (err: any) => {
        this.formSubmitBranch = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error adding branch");
      }
    );
  }

  addDepartment_info() {
    this.formSubmitDepartment = true;
    if (!this.departmentForm.valid) {
      this.formSubmitDepartment = false;
      this.toastr.error("Please fill in all required fields for Department");
      return;
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "departmentName": this.departmentForm.get('departmentName').value,
      "cid": Number(this.selectedCompanyForUser.cid),
    };

    this.generic_service.addDepartment_info(body).subscribe(
      (response: any) => {
        this.formSubmitDepartment = false;
        this.toastr.success(response.message || "Department Added");
        this.getAllDepartment_infoByCid(this.selectedCompanyForUser.cid);
        document.getElementById('closeAddDepartmentModalBtn')?.click();
      },
      (err: any) => {
        this.formSubmitDepartment = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error adding department");
      }
    );
  }

  updateBlockStatus(companyInfoId: any, isBlocked: boolean) {
    this.generic_service.updateBlockStatus(companyInfoId, isBlocked).subscribe(
      (response: any) => {
        this.toastr.success(response.message || "Status Updated");
        this.getAllCompanyInfo();
        if (this.singleCompanyInfoData && this.singleCompanyInfoData.length > 0 && this.singleCompanyInfoData[0].companyInfoId === companyInfoId) {
          this.singleCompanyInfoData[0].isBlocked = isBlocked;
        }
      },
      (err: any) => {
        this.toastr.error(err.error?.errors?.[0]?.description || "Error updating status");
      }
    );
  }
}
